// articles.js
export const articles = [
  {
    id: 1,
    title: "Sustainable Agriculture Practices",
    summary: "Learn how Agrolix Group is leading the way in sustainable farming.",
    image: "https://via.placeholder.com/150",
    date: "2025-08-01"
  },
  {
    id: 2,
    title: "Seed Quality Control",
    summary: "Our rigorous quality control ensures the best seeds for farmers.",
    image: "https://via.placeholder.com/150",
    date: "2025-07-15"
  }
];
